import {Accordion, AccordionItem} from "@nextui-org/react";
import React  from "react";
import { ChevronLeft } from "lucide-react";
import styled from "styled-components";

const Wrap = styled.div`
  width: 95%;
  max-width: 1100px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  border: 1px solid #d7e6f8;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  padding: 14px;
`;

export default function App() {
  const defaultContent =
    "Reliable tradespeople are typically recommended by reviews, portfolios of previous work, and testimonials. However, finding this information can be time-consuming. We vet all professionals including electricians, plumbers, decorators and more, making it easy for you to find the right local tradesperson near you. Verified reviews from real clients make it easy to identify trustworthy professionals.";
  const defaultContent1 =
    "Searching for tradespeople on your own can take days or weeks. Our platform streamlines this process, connecting you with skilled professionals within minutes so you can get your job started quickly.";
  const defaultContent2 =
    "We prioritise safety and quality. All tradesmen listed on our site are vetted for proper qualifications, licenses, and insurance so you can hire with confidence.";
  const defaultContent3 =
    "Our platform saves you time, stress, and money. By offering a simple job-posting process, competitive quotes, verified tradesmen, and real customer reviews, we ensure you get the right tradesman, quickly and without hassle.";
   
  const CustomChevron = ({ isOpen }) => (
  <ChevronLeft
    style={{
      transform: isOpen ? "rotate(-90deg)" : "rotate(0deg)", // Anti-clockwise rotation
      transition: "transform 0.3s ease",
      fontSize: "24px",
      strokeWidth: 3, // Make it bolder
      color: "#0068C9", // Custom electric blue or your theme color
    }}
  />
);




  return (
    <Wrap>
    <Accordion itemClasses={{ title: "text-md font-bold" }}>
      <AccordionItem
        key="1"
        title="How do I find a reliable electrician, plumber or tradesperson near me?"
        indicator={({ isOpen }) => <CustomChevron isOpen={isOpen} />}
      >
        {defaultContent}
      </AccordionItem>
      <AccordionItem
        key="2"
        title="How long does it take to get connected with a good tradesman?"
        indicator={({ isOpen }) => <CustomChevron isOpen={isOpen} />}
      >
        {defaultContent1}
      </AccordionItem>
      <AccordionItem
        key="3"
        title="Are tradesmen on this platform insured and qualified?"
        indicator={({ isOpen }) => <CustomChevron isOpen={isOpen} />}
      >
        {defaultContent2}
      </AccordionItem>
      <AccordionItem
        key="4"
        title="What are the benefits of using this site over other options?"
        indicator={({ isOpen }) => <CustomChevron isOpen={isOpen} />}
      >
        {defaultContent3}
      </AccordionItem>
    </Accordion>
    </Wrap>
  );
}
